import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

var _dec, _class;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as _ from 'lodash';
import Paper from 'material-ui/Paper';
import { Tabs, Tab } from 'material-ui/Tabs';
import AdDetailOverview from './AdDetailOverview';
import AdDetailTargeting from './AdDetailTargeting';
import AdDetailResults from './AdDetailResults';
import { SocialNetworkIcon, ButtonBar } from 'components';
import moment from 'moment';
import { connect } from 'react-redux';
import * as styles from './AdDetails.scss';
var AdDetails = (_dec = connect(function (state, ownProps) {
  return {
    theme: state.theme
  };
}, {}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(AdDetails, _Component);

  var _super = _createSuper(AdDetails);

  function AdDetails(props) {
    var _this;

    _classCallCheck(this, AdDetails);

    _this = _super.call(this, props);
    _this.state = {
      platformTypeTab: props.adDetails && Object.keys(props.adDetails.insights).filter(function (k) {
        return k !== 'summary';
      }).length > 0 ? Object.keys(props.adDetails.insights).filter(function (k) {
        return k !== 'summary';
      }).length > 1 ? 'summary' : Object.keys(props.adDetails.insights).filter(function (k) {
        return k !== 'summary';
      })[0] : ''
    };
    return _this;
  }
  /** *********************************************************
   RENDER
   ***********************************************************/


  _createClass(AdDetails, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var adDetails = this.props.adDetails;
      var insights = adDetails.insights;
      var creative = adDetails.creative;
      var imageUrl = creative.thumbnail_url;

      if (creative.object_attachments) {
        for (var i = 0; i < creative.object_attachments.length; i++) {
          if (creative.object_attachments[i].media) {
            imageUrl = creative.object_attachments[i].media[Object.keys(creative.object_attachments[i].media)[0]].src;
            break;
          }
        }
      }

      var overviewAdDetails = insights ? _objectSpread(_objectSpread({}, this.props.adDetails), {}, {
        insights: _objectSpread(_objectSpread({}, this.props.adDetails.insights), Object.keys(insights).filter(function (k) {
          return k !== 'summary';
        }).length > 1 ? {
          summary: insights.summary
        } : {
          summary: undefined
        })
      }) : {};
      console.log('overviewAdDetails', overviewAdDetails);
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: styles.adCardPreview
      }, /*#__PURE__*/React.createElement(Tabs, {
        inkBarStyle: {
          backgroundColor: this.props.theme.colors.primaryColor
        }
      }, /*#__PURE__*/React.createElement(Tab, {
        label: "Overview"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flexDirection: 'column',
          padding: '0 16px'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.modalAdDates
      }, "Ad Dates:", ' ', "".concat(moment(adDetails.campaign.start_time).format('M/DD/YY'), " - ").concat(moment(adDetails.campaign.stop_time).format('M/DD/YY'))), !this.props.upcoming && insights && Object.keys(insights).length > 1 && /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 8,
          marginBottom: 8
        }
      }, /*#__PURE__*/React.createElement(ButtonBar, {
        items: [].concat(_toConsumableArray(Object.keys(insights).filter(function (k) {
          return k !== 'summary';
        }).length > 1 ? [{
          title: 'Summary',
          key: 'summary',
          selected: this.state.platformTypeTab === 'summary'
        }] : []), _toConsumableArray(Object.keys(insights).filter(function (k) {
          return k !== 'summary';
        }).map(function (key) {
          if (Object.keys(insights[key]).length > 0) {
            return {
              title: _.startCase(key),
              key: key,
              selected: _this2.state.platformTypeTab === key
            };
          }
        }).filter(function (t) {
          return t;
        }))),
        onChange: function onChange(val) {
          _this2.setState({
            platformTypeTab: val.key
          });
        }
      })), /*#__PURE__*/React.createElement(AdDetailOverview, {
        platformType: this.state.platformTypeTab,
        adDetails: overviewAdDetails
      }))), !this.props.upcoming && insights.facebook && insights.facebook.objective === 'LEAD_GENERATION' && /*#__PURE__*/React.createElement(Tab, {
        label: "Results"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(AdDetailResults, {
        adDetails: this.props.adDetails
      }))), /*#__PURE__*/React.createElement(Tab, {
        label: "Targeting"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          padding: 16
        }
      }, /*#__PURE__*/React.createElement(AdDetailTargeting, {
        adDetails: this.props.adDetails
      }))))));
    }
  }]);

  return AdDetails;
}(Component)) || _class);
export default AdDetails;